/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_AgentsInputs */

const cs_reports_agents = /** @type {(inputs: Reports_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výkon makléřů`)
};

const en_reports_agents = /** @type {(inputs: Reports_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent performance`)
};

/**
* | output |
* | --- |
* | "Agent performance" |
*
* @param {Reports_AgentsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const reports_agents = /** @type {((inputs?: Reports_AgentsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_AgentsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_agents(inputs)
	return cs_reports_agents(inputs)
});